"use strict";

function getRecentlyViewedProducts() {
  let recentlyViewedProducts = localStorage.getItem("recentlyViewedProducts");

  try {
    recentlyViewedProducts = JSON.parse(recentlyViewedProducts);
  } catch (error) {
    recentlyViewedProducts = [];
  }

  return Array.isArray(recentlyViewedProducts) ? recentlyViewedProducts : [];
}

function saveRecentlyViewedProducts(recentlyViewedProducts) {
  recentlyViewedProducts = recentlyViewedProducts.slice(-24);
  localStorage.setItem("recentlyViewedProducts", JSON.stringify(recentlyViewedProducts));
  return recentlyViewedProducts;
}

if (window.lastViewedProductId) {
  let recentlyViewedProducts = getRecentlyViewedProducts().filter(function (viewedProduct) {
    return viewedProduct.id !== window.lastViewedProductId;
  });

  recentlyViewedProducts.push({
    timestamp: Date.now(),
    id: window.lastViewedProductId,
  });

  saveRecentlyViewedProducts(recentlyViewedProducts);
}

if (!customElements.get("recently-viewed-products")) {
  customElements.define(
    "recently-viewed-products",
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.recentlyViewedProducts = getRecentlyViewedProducts();
        this.fetched = false;
      }

      connectedCallback() {
        if (!this.fetched) {
          this.fetchProducts();
        }
      }

      fetchProducts() {
        const products = this.recentlyViewedProducts.slice().filter((product) => {
          return product.id !== window.lastViewedProductId;
        });

        if (!products.length || !window.routes || !window.routes.search_url) {
          this.style.display = "none";
          return;
        }

        const searchString = products
          .slice()
          .reverse()
          .map((product) => {
            return "id:" + product.id;
          })
          .join(" OR ");

        fetch(
          window.routes.search_url +
            "?section_id=" +
            this.dataset.sectionId +
            "&type=product&q=" +
            encodeURIComponent(searchString),
        )
          .then((response) => response.text())
          .then((content) => {
            const html = document.createElement("div");
            html.innerHTML = content;

            const remote = html.querySelector("recently-viewed-products");
            if (!remote) {
              this.style.display = "none";
              return;
            }

            this.innerHTML = remote.innerHTML;
            this.fetched = true;
            this.decorateCards();
          })
          .catch(() => {
            this.style.display = "none";
          });
      }

      decorateCards() {
        const cards = this.querySelectorAll("[data-recently-viewed-product-id]");
        if (!cards.length) {
          this.style.display = "none";
          return;
        }

        cards.forEach((card) => {
          const productId = card.getAttribute("data-recently-viewed-product-id");
          if (!productId) return;
        });
      }
    },
  );
}
